import { render, staticRenderFns } from "./room-member.vue?vue&type=template&id=5efac1b9&scoped=true&"
import script from "./room-member.vue?vue&type=script&lang=js&"
export * from "./room-member.vue?vue&type=script&lang=js&"
import style0 from "./room-member.vue?vue&type=style&index=0&id=5efac1b9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efac1b9",
  null
  
)

export default component.exports